//id = [1...42] (integers)
//link = "#event_name" (empty)
//category = sports tech culture 
//priority = [true, false]
//name = [event_name]
//disc = "lorem ipsum"
//time = "3:00 PM" (dummy)
//date = "10-10-22" (dummy)
//venue = "Atharva College Of Engineering"
//reg = "integer"
//prize = "integer"
//teamEvent = [YES, NO] (string)
//individualEvent = [YES, NO] (string)
//winners = "string"

export const EventsData = [
    {
        id: 1,
        link: "#TREASURE HUNT",
        category: "SPECIAL ATTRACTION EVENTS",
        priority: true,
        name: "TREASURE HUNT",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "200",
        value: "200",
        prize: "4000",
        teamEvent: "YES",
        individualEvent: "NO",
        winners: "1"
    },
    {
        id: 2,
        link: "#FOOTBALL POOL",
        category: "SPECIAL ATTRACTION EVENTS",
        priority: true,
        name: "FOOTBALL POOL",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "100",
        value: "100",
        prize: "4000",
        teamEvent: "No",
        individualEvent: "YES",
        winners: "1 Team/ per day"
    },
    {
        id: 3,
        link: "#TIME FREEZE",
        category: "SPECIAL ATTRACTION EVENTS",
        priority: true,
        name: "TIME FREEZE",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "FREE",
        value: "FREE",
        prize: "1000",
        teamEvent: "NO",
        individualEvent: "YES",
        winners: "1 Team/per day"
    },
    {
        id: 4,
        link: "#TRI-TECH",
        category: "SPECIAL ATTRACTION EVENTS",
        priority: true,
        name: "TRI-TECH",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "100",
        value: "100",
        prize: "2000",
        teamEvent: "NO",
        individualEvent: "YES",
        winners: "1"
    },
    {
        id: 5,
        link: "#SOCCER TIC-TIC-TAE",
        category: "SPECIAL ATTRACTION EVENTS",
        priority: true,
        name: "SOCCER TIC-TIC-TAE",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "50",
        value: "50",
        prize: "2000",
        teamEvent: "",
        individualEvent: "",
        winners: ""
    },
    {
        id: 6,
        link: "#BOX CRICKET",
        category: "PRE EVENTS",
        priority: true,
        name: "BOX CRICKET",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "6v6 300",
        value: "6v6 300",
        prize: "3500 , 2000",
        teamEvent: "YES",
        individualEvent: "NO",
        winners: "1 team "
    },
    {
        id: 7,
        link: "#RINK FOOTBALL",
        category: "PRE EVENTS",
        priority: true,
        name: "RINK FOOTBALL",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "4v4 250 ",
        value: "4v4 250 ",
        prize: "2500 ,1000",
        teamEvent: "YES",
        individualEvent: "NO",
        winners: "1 team "
    },
    {
        id: 8,
        link: "#VOLLEYBALL",
        category: "PRE EVENTS",
        priority: true,
        name: "VOLLEYBALL",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "6v6 300",
        value: "6v6 300",
        prize: "2000  1500",
        teamEvent: "YES",
        individualEvent: "NO",
        winners: ""
    },
    {
        id: 9,
        link: "#ROBO MAZE",
        category: "TECHNICAL EVENTS",
        priority: true,
        name: "ROBO MAZE",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "",
        value: "",
        prize: "1500",
        teamEvent: "NO",
        individualEvent: "YES",
        winners: "1"
    },
    {
        id: 10,
        link: "#BOT AND THE BONE",
        category: "TECHNICAL EVENTS",
        priority: true,
        name: "BOT AND THE BONE",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "80",
        value: "80",
        prize: "1500",
        teamEvent: "NO",
        individualEvent: "YES",
        winners: "1"
    },
    {
        id: 11,
        link: "#ROBOSUMO",
        category: "TECHNICAL EVENTS",
        priority: true,
        name: "ROBOSUMO",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "80",
        value: "80",
        prize: "1500",
        teamEvent: "NO",
        individualEvent: "YES",
        winners: "1 team "
    },
    {
        id: 12,
        link: "#RC RACING",
        category: "TECHNICAL EVENTS",
        priority: true,
        name: "RC RACING",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "80",
        value: "80",
        prize: "2000",
        teamEvent: "NO",
        individualEvent: "YES",
        winners: "1"
    },
    {
        id: 13,
        link: "#BLIND CODING",
        category: "TECHNICAL EVENTS",
        priority: true,
        name: "BLIND CODING",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "100",
        value: "100",
        prize: "1000",
        teamEvent: "NO",
        individualEvent: "YES",
        winners: "1"
    },
    {
        id: 14,
        link: "#BLUEPRINT",
        category: "TECHNICAL EVENTS",
        priority: true,
        name: "BLUEPRINT",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "50",
        value: "50",
        prize: "1000",
        teamEvent: "NO",
        individualEvent: "YES",
        winners: "1"
    },
    {
        id: 15,
        link: "#BUG BOUNTY",
        category: "TECHNICAL EVENTS",
        priority: true,
        name: "BUG BOUNTY",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "50",
        value: "50",
        prize: "1000",
        teamEvent: "NO",
        individualEvent: "YES",
        winners: ""
    },
    {
        id: 16,
        link: "#INNOVATOR",
        category: "TECHNICAL EVENTS",
        priority: true,
        name: "                          INNOVATOR",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "150",
        value: "150",
        prize: "3000",
        teamEvent: "YES",
        individualEvent: "YES",
        winners: "2"
    },
    {
        id: 17,
        link: "#LOGO DESIGNING ",
        category: "TECHNICAL EVENTS",
        priority: true,
        name: "LOGO DESIGNING ",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "100",
        value: "100",
        prize: "2000",
        teamEvent: "NO",
        individualEvent: "YES",
        winners: "2"
    },
    {
        id: 18,
        link: "#HACKATHON",
        category: "TECHNICAL EVENTS",
        priority: true,
        name: "HACKATHON",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "100",
        value: "100",
        prize: "2000",
        teamEvent: "YES",
        individualEvent: "NO",
        winners: "1 team "
    },
    {
        id: 19,
        link: "#WEBSTER",
        category: "TECHNICAL EVENTS",
        priority: true,
        name: "WEBSTER",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "150",
        value: "150",
        prize: "2000",
        teamEvent: "YES",
        individualEvent: "NO",
        winners: ""
    },
    {
        id: 20,
        link: "#TARGET SHOOTING",
        category: "FUN EVENTS",
        priority: true,
        name: "TARGET SHOOTING",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "50",
        value: "50",
        prize: "1000",
        teamEvent: "",
        individualEvent: "",
        winners: ""
    },
    {
        id: 21,
        link: "#DEBATE",
        category: "FUN EVENTS",
        priority: true,
        name: "DEBATE",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "50",
        value: "50",
        prize: "1000",
        teamEvent: "",
        individualEvent: "",
        winners: ""
    },
    {
        id: 22,
        link: "#RUBIKS CUBE",
        category: "FUN EVENTS",
        priority: true,
        name: "RUBIKS CUBE",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "30",
        value: "30",
        prize: "1000",
        teamEvent: "",
        individualEvent: "",
        winners: ""
    },
    {
        id: 23,
        link: "#CHESS",
        category: "FUN EVENTS",
        priority: true,
        name: "CHESS",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "50",
        value: "50",
        prize: "2000",
        teamEvent: "",
        individualEvent: "",
        winners: ""
    },
    {
        id: 24,
        link: "#CARROM",
        category: "FUN EVENTS",
        priority: true,
        name: "CARROM",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "(1v1)50,(2v2)100",
        value: "(1v1)50,(2v2)100",
        prize: "1000  2000",
        teamEvent: "",
        individualEvent: "",
        winners: ""
    },
    {
        id: 25,
        link: "#SPELL BEE",
        category: "FUN EVENTS",
        priority: true,
        name: "SPELL BEE",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "FREE",
        value: "FREE",
        prize: "1000",
        teamEvent: "YES",
        individualEvent: "YES",
        winners: "2"
    },
    {
        id: 26,
        link: "#HOGATHON",
        category: "FUN EVENTS",
        priority: true,
        name: "HOGATHON",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "50",
        value: "50",
        prize: "2000",
        teamEvent: "",
        individualEvent: "",
        winners: ""
    },
    {
        id: 27,
        link: "#TEXT IT",
        category: "FUN EVENTS",
        priority: true,
        name: "TEXT IT",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "FREE",
        value: "FREE",
        prize: "1000",
        teamEvent: "NO",
        individualEvent: "YES",
        winners: "1"
    },
    {
        id: 28,
        link: "#TUG OF WAR",
        category: "FUN EVENTS",
        priority: true,
        name: "TUG OF WAR",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "150(TEAM)",
        value: "150(TEAM)",
        prize: "2000",
        teamEvent: "",
        individualEvent: "",
        winners: ""
    },
    {
        id: 29,
        link: "#MAD ADS",
        category: "FUN EVENTS",
        priority: true,
        name: "MAD ADS",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "50",
        value: "50",
        prize: "",
        teamEvent: "",
        individualEvent: "",
        winners: ""
    },
    {
        id: 30,
        link: "#OOBLECK",
        category: "FUN EVENTS",
        priority: true,
        name: "OOBLECK",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "50",
        value: "50",
        prize: "",
        teamEvent: "",
        individualEvent: "",
        winners: ""
    },
    {
        id: 31,
        link: "#KGF",
        category: "FUN EVENTS",
        priority: true,
        name: "KGF",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "50",
        value: "50",
        prize: "",
        teamEvent: "",
        individualEvent: "",
        winners: ""
    },
    {
        id: 32,
        link: "#PES 2022",
        category: "GAMING EVENTS",
        priority: true,
        name: "PES 2022",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "1V1 50 ",
        value: "1V1 50 ",
        prize: "2000",
        teamEvent: "NO",
        individualEvent: "YES",
        winners: "2"
    },
    {
        id: 33,
        link: "#VALORANT",
        category: "GAMING EVENTS",
        priority: true,
        name: "VALORANT",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "5v5 250 ",
        value: "5v5 250 ",
        prize: "4000",
        teamEvent: "YES",
        individualEvent: "YES",
        winners: "2 team "
    },
    {
        id: 34,
        link: "#CALL OF DUTY",
        category: "GAMING EVENTS",
        priority: true,
        name: "CALL OF DUTY",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "5v5 200 ",
        value: "5v5 200 ",
        prize: "2500",
        teamEvent: "YES",
        individualEvent: "YES",
        winners: "2 team "
    },
    {
        id: 35,
        link: "#NEON FOOTBALL",
        category: "NEON EVENTS",
        priority: true,
        name: "NEON FOOTBALL",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "3V3 150",
        value: "3V3 150",
        prize: "2000",
        teamEvent: "YES",
        individualEvent: "NO",
        winners: "1 team "
    },
    {
        id: 36,
        link: "#NEON CRICKET",
        category: "NEON EVENTS",
        priority: true,
        name: "NEON CRICKET",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "4v4 200 ",
        value: "4v4 200 ",
        prize: "2000",
        teamEvent: "YES",
        individualEvent: "NO",
        winners: "1 team "
    },
    {
        id: 37,
        link: "#NEON SHOOTING",
        category: "NEON EVENTS",
        priority: true,
        name: "NEON SHOOTING",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "",
        value: "",
        prize: "",
        teamEvent: "",
        individualEvent: "",
        winners: ""
    },
    {
        id: 38,
        link: "#ARM WRESTLING",
        category: "STRONGMAN EVENTS",
        priority: true,
        name: "ARM WRESTLING",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "1V1 FREE",
        value: "1V1 FREE",
        prize: "1000",
        teamEvent: "NO",
        individualEvent: "YES",
        winners: "1"
    },
    {
        id: 39,
        link: "#BICEP CURL",
        category: "STRONGMAN EVENTS",
        priority: true,
        name: "BICEP CURL",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "1V1 50",
        value: "1V1 50",
        prize: "1000",
        teamEvent: "NO",
        individualEvent: "YES",
        winners: "2"
    },
    {
        id: 40,
        link: "#DEADLIFT",
        category: "STRONGMAN EVENTS",
        priority: true,
        name: "DEADLIFT",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "1V1 100",
        value: "1V1 100",
        prize: "2000",
        teamEvent: "NO",
        individualEvent: "YES",
        winners: "2"
    },
    {
        id: 41,
        link: "#SQUATS",
        category: "STRONGMAN EVENTS",
        priority: true,
        name: "SQUATS",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "1V1 50",
        value: "1V1 50",
        prize: "1000",
        teamEvent: "NO",
        individualEvent: "YES",
        winners: "2"
    },
    {
        id: 42,
        link: "#PUSHUPS VARIATION",
        category: "STRONGMAN EVENTS",
        priority: true,
        name: "PUSHUPS VARIATION",
        disc: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Adipisci tenetur dignissimos minus error laboriosam.",
        time: "3:00 PM",
        date: "10-10-22",
        venue: "Atharva College Of Engineering",
        reg: "FREE",
        value: "FREE",
        prize: "1000",
        teamEvent: "NO",
        individualEvent: "YES",
        winners: "2"
    }
]